import React, { useEffect, useState } from 'react';
// @ts-expect-error ts-migrate(2305) FIXME: Module '"react-router"' has no exported member 'Ro... Remove this comment to see the full error message
import { RouterHistory } from 'react-router';

import { RecommendedActionsBlockData } from 'api/cms';
import { CurrentUser } from 'api/currentUser';
import { RecommendedAction } from 'api/types/shared.types';
import Box from 'components/Box';
import { TileCarousel } from 'components/TileCarousel';
import algoliaSearch from 'utils/algoliaSearch';
import getSearchConfig from 'utils/search/getSearchConfig';
import getSearchLocationOptions from 'utils/search/getSearchLocationOptions';
import getVolopsSearchIndex from 'utils/search/getVolopsSearchIndex';
import { listingSearchHomePath } from 'utils/searchHomePages';

const getActions = (currentUser: CurrentUser | null | undefined) => {
  const searchConfig = getSearchConfig();
  let locationOptions = {};

  if (
    currentUser &&
    currentUser.searchLocation &&
    currentUser.searchLocation.latitude &&
    currentUser.searchLocation.longitude
  ) {
    locationOptions = getSearchLocationOptions(
      'auto',
      currentUser.searchLocation
    ).locationOptions;
  }

  const queryOptions = {
    index: getVolopsSearchIndex(),
    filters: 'type:VOLOP AND source:IDEALIST',
    hitsPerPage: 20,
    attributesToRetrieve: [
      'objectID',
      'name',
      'city',
      'state',
      'logo',
      'orgName',
      'url',
    ],
    ...locationOptions,
  };
  return algoliaSearch(searchConfig, '', queryOptions)
    .then(({ hits }) => hits)
    .catch();
};

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const RecommendedActionsBlock = ({
  data: { headline },
  history,
}: {
  data: RecommendedActionsBlockData;
  history: RouterHistory;
}) => {
  const [recommendedActions, setRecommmendedActions] = useState([]);
  useEffect(() => {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1 arguments, but got 0.
    getActions().then((actions: Array<RecommendedAction>) => {
      setRecommmendedActions(actions);
    });
  }, []);
  return (
    <Box data-qa-id="recommended-actions">
      <TileCarousel
        headline={headline}
        results={recommendedActions}
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ headline: string; results: any[]; history:... Remove this comment to see the full error message
        history={history}
        seeAllText={
          /* TRANSLATORS: Link to actions search */
          getText('See all Actions')
        }
        seeAllUrl={`${listingSearchHomePath('VOLOP')}`}
        listingType="ACTION"
      />
    </Box>
  );
};

// eslint-disable-next-line import/no-default-export
export default RecommendedActionsBlock;
